import { render, staticRenderFns } from "./grnReco.vue?vue&type=template&id=11c3e120&scoped=true"
import script from "./grnReco.vue?vue&type=script&lang=js"
export * from "./grnReco.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./grnReco.vue?vue&type=style&index=1&id=11c3e120&prod&scoped=true&lang=css"
import style2 from "./grnReco.vue?vue&type=style&index=2&id=11c3e120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3e120",
  null
  
)

export default component.exports